// extracted by mini-css-extract-plugin
module.exports =  {"location-switcher":"d30e7684c4--location-switcher--uUTHr","footer":"d30e7684c4--footer--DdlhS","preloader-wrapper":"d30e7684c4--preloader-wrapper--mVvWN"};